<template>
    <div class="content">
        <CustomTable ref="CustomTable" v-loading="loading" @init="init" @handelBtnClick="handelBtnClick"
            @handelTableChange="handelTableChange" @handelTableClick="handelTableClick" :filterData="filterData"
            :headerData="headerData" :btnsData="btnsData" :data="data" :pagination="pagination">
            <el-table-column label="操作" fixed="right" align="center" width="100px">
                <template slot-scope="scope">
                    <el-link @click="handelTableClick(scope.row, 'edit')">编辑</el-link>
                    <el-popconfirm title="确定删除吗？" @confirm="handelTableClick(scope.row, 'delete')">
                        <el-link slot="reference">删除</el-link>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </CustomTable>
        <el-dialog :title="createdType == 'add' ? '新增管理员' : '修改管理员信息'" :visible.sync="dialogVisible" width="800px"
            :close-on-click-modal="false">
            <CustomForm ref="CustomForm" :data="addFormData" @change="handelForm" />
        </el-dialog>
    </div>
</template>
  
<script>
import CustomForm from "@/components/custom/CustomForm";
import CustomTable from "@/components/custom/CustomTable";
export default {
    components: { CustomForm, CustomTable },
    data() {
        return {
            filterData: [
                { label: "管理员账号", prop: "userName", type: "input", value: "", span: 8 },
                { label: "管理员姓名", prop: "name", type: "input", value: "", span: 8 },
                // { label: "邮箱", prop: "email", type: "input", value: "", span: 8 },
                {
                    label: "状态",
                    prop: "status",
                    type: "select",
                    value: "",
                    opt: [
                        { label: "启用", value: true },
                        { label: "禁用", value: false },
                    ],
                    span: 8
                },
                { label: "角色", prop: "role", type: "select", value: "", opt: [{ label: "超级管理员", value: "SUPERADMIN" }, { label: "内容管理员", value: "CONTENTAUDIT" }, { label: "用户管理员", value: "USERADMIN" }], span: 8 },
            ],
            headerData: [
                { label: "管理员账号", prop: "userName" },
                { label: "管理员姓名", prop: "name" },
                // { label: "邮箱", prop: "email" },
                { label: "权限", prop: "role" },
                { label: "状态", prop: "status", type: "switch" },
            ],
            btnsData: [{ label: "新增", value: "add", type: "primary" }],
            data: [],
            addFormData: [
                { label: "账号", prop: "userName", type: "input", value: "", required: true, span: 24, disabled: true },
                { label: "用户姓名", prop: "name", type: "input", value: "", required: true, span: 24 },
                // { label: "邮箱", prop: "email", type: "input", value: "", required: true, span: 24 },
                { label: "角色", prop: "role", type: "select", value: "", required: true, opt: [{ label: "超级管理员", value: "SUPERADMIN" }, { label: "内容管理员", value: "CONTENTAUDIT" }, { label: "用户管理员", value: "USERADMIN" }], span: 12 },
            ],
            loading: false,
            pagination: {
                pageSize: 10,
                current: 1,
                total: 0,
            },
            selectData: {},
            dialogVisible: false,
            createdType: ""
        };
    },
    methods: {
        handelTableChange(data) {
            let url = ""
            let params = {}
            switch (data.prop) {
                case "status":
                    url = this.$api.Management.accountStatus
                    params = {
                        status: data.data.status ? "active" : "inactive"
                    }
                    break;
                case "auditingStatus":
                    url = this.$api.Management.accountAuditing
                    params = data.value
                    break;
            }
            this.$https
                .post(url + data.data.id, params)
                .then((res) => {
                    this.$message.success("修改成功")
                    this.$refs.CustomTable.search()
                });
        },
        handelForm(data) {
            if (!Object.keys(data).length) {
                this.dialogVisible = false;
                return;
            }
            const url = this.createdType == "add" ? this.$api.Management.accountAdd : this.$api.Management.accountUpdate + this.selectData.id
            this.$https
                .post(url, { ...data, status: "active" })
                .then((res) => {
                    this.$message.success(this.createdType == "add" ? "新增正常" : "修改成功")
                    this.dialogVisible = false;
                    this.$refs.CustomTable.search()
                });
        },
        handelTableClick(data, type) {
            this.createdType = type;
            switch (type) {
                case "delete":
                    this.$https
                        .post(this.$api.Management.accountDelete + data.id)
                        .then((res) => {
                            this.$message.success("删除成功")
                            this.$refs.CustomTable.search()
                        });
                    break;
                case "edit":
                    this.selectData = data
                    this.addFormData = [
                        { label: "账号", prop: "userName", type: "input", value: "", required: true, span: 24, disabled: true },
                        { label: "密码", prop: "password", type: "input", value: "", required: true, span: 24 },
                        { label: "用户姓名", prop: "name", type: "input", value: "", required: true, span: 24 },
                        // { label: "邮箱", prop: "email", type: "input", value: "", required: true, span: 24 },
                        { label: "角色", prop: "role", type: "select", value: "", required: true, opt: [{ label: "超级管理员", value: "SUPERADMIN" }, { label: "内容管理员", value: "CONTENTAUDIT" }, { label: "用户管理员", value: "USERADMIN" }], span: 12 },
                    ]
                    this.$https.get(this.$api.Management.accountDetails + data.id).then(res => {
                        this.addFormData = this.addFormData.map((el) => {
                            return Object.assign(el, { value: el.prop == 'img' ? (res[el.prop] ?[res[el.prop]] : []) : (res[el.prop] || el.value) });
                        });
                        this.dialogVisible = true;
                    })
                    break;
            }
        },
        handelBtnClick(type) {
            this.createdType = type;
            switch (type) {
                case "add":
                    this.addFormData = [
                        { label: "账号", prop: "userName", type: "input", value: "", required: true, span: 24 },
                        { label: "密码", prop: "password", type: "input", value: "", required: true, span: 24 },
                        { label: "用户姓名", prop: "name", type: "input", value: "", required: true, span: 24 },
                        // { label: "邮箱", prop: "email", type: "input", value: "", required: true, span: 24 },
                        { label: "角色", prop: "role", type: "select", value: "", required: true, opt: [{ label: "超级管理员", value: "SUPERADMIN" }, { label: "内容管理员", value: "CONTENTAUDIT" }, { label: "用户管理员", value: "USERADMIN" }], span: 12 },
                    ]
                    this.dialogVisible = true;
                    break;
            }
        },
        init(data) {
            this.loading = true;
            let params = Object.assign({}, data);
            if (params && Object.keys(params).includes("status")) {
                params.status = params.status ? "active" : "inactive";
            }
            params.current -= 1
            console.log(params)
            this.$https
                .get(this.$api.Management.accountList, params)
                .then((res) => {
                    this.pagination = {
                        pageSize: res.pageSize,
                        current: res.currentPage + 1,
                        total: res.count,
                    };
                    this.data = res.data
                        ? res.data.map((el) => {
                            return Object.assign(el, {
                                status: el.status == "active" ? true : false,
                                role: el.role == "SUPERADMIN" ? "超级管理员" : (el.role == "USERADMIN" ? "用户管理员" : "内容管理员")
                            });
                        })
                        : [];
                    this.loading = false;
                });
        },
    },
};
</script>
  
<style lang="scss" scoped>
.content {
    position: relative;
    width: 100%;
    overflow: hidden;
}

/deep/.el-dialog__body {
    padding: 0;
}
</style>